const meta = {
  module: "transport-categories"
};

export default [
  {
    path: `/transport-categories`,
    redirect: "/transport-categories/page/1"
  },
  {
    path: `/transport-categories/page`,
    redirect: "/transport-categories/page/1"
  },
  {
    path: `/transport-categories/page/:page`,
    name: "transport-types",
    component: () =>
      import(
        /* webpackChunkName: "transport-types" */ "@/modules/transport-types/views/index.vue"
      ),
    meta: {
      ...meta
    }
  },
  {
    path: `/transport-categories/create`,
    name: "transport-types/create",
    component: () =>
      import(
        /* webpackChunkName: "transport-types/create" */ "@/modules/transport-types/views/create.vue"
      ),
    meta: {
      ...meta,
      action: "create"
    }
  },
  {
    path: `/transport-categories/edit/:id`,
    name: "transport-types/edit",
    component: () =>
      import(
        /* webpackChunkName: "transport-types/edit" */ "@/modules/transport-types/views/edit.vue"
      ),
    meta: {
      ...meta,
      action: "edit"
    }
  }
];
